import MuiTypography from "@mui/material/Typography";
import type { TypographyProps as MuiTypographyProps } from "@mui/material/Typography";
import type { SystemStyleObject, Theme } from "@mui/system";

export interface TypographyProps extends MuiTypographyProps {
  bold?: boolean;
}

export function Typography({ variant, children, bold, sx, ...props }: TypographyProps) {
  return (
    <MuiTypography
      variant={variant}
      sx={{
        fontWeight: bold ? "bold" : "normal",
        ...(sx as SystemStyleObject<Theme>),
      }}
      {...props}
    >
      {children}
    </MuiTypography>
  );
}
